import { useEffect, useRef, useState } from 'react'

export const useComponentSize = () => {
  const ref = useRef<HTMLDivElement>(null)
  const [size, setSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    if (!ref.current) return

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        setSize({
          width: entry.contentRect.width,
          height: entry.contentRect.height,
        })
      }
    })

    resizeObserver.observe(ref.current)
    return () => resizeObserver?.disconnect?.()
  }, [])

  return { ref, size }
}
